import { CHANGE_SALE_DISCLAIMER_SPEC, useFormatSaleDisclaimerEndDate } from '@wix/package-picker-shared';
import { SaleType } from '@wix/package-picker-sdk';
import { useCurrentModule } from '../ModuleProvider';
import { useRedesignedDisclaimers } from '../../hooks/useRedesignedDisclaimers';
import { useLocaleAndGeo } from '../../hooks/useLocaleAndGeo';
import { REDESIGNED_PERSONAL_SALE_KEY, REDESIGNED_SEASONAL_SALE_KEY, SEASONAL_SALE_TYPES } from '../../utils';
export const SaleDisclaimer = () => {
  var _data$discount$discou;
  const module = useCurrentModule();
  const {
    t
  } = module.internals.useTranslations();
  const {
    locale,
    geo,
    isLoading: isLocaleAndGeoLoading
  } = useLocaleAndGeo();
  const {
    experiments
  } = module.internals.experiments.hooks.useExperiments();
  const formatSaleDate = useFormatSaleDisclaimerEndDate({
    locale,
    geo,
    isChangeSaleDisclaimerEnabled: experiments.isEnabled(CHANGE_SALE_DISCLAIMER_SPEC)
  });
  const isRedesignEnabled = useRedesignedDisclaimers();
  const {
    data
  } = module.SDK.eclipseOfferingApiClient.hooks.useFetchOfferingDiscount({});
  if (!(data != null && data.hasSale) || isLocaleAndGeoLoading) {
    return null;
  }
  const saleType = (_data$discount$discou = data.discount.discountInfo.sale) == null ? void 0 : _data$discount$discou.saleType;
  const expiresAt = data.discount.expiresAt;
  if (SEASONAL_SALE_TYPES.has(saleType) && expiresAt) {
    return t(isRedesignEnabled ? REDESIGNED_SEASONAL_SALE_KEY : 'sale.footer.offer', {
      date: formatSaleDate(expiresAt)
    });
  }
  if (saleType === SaleType.PERSONAL_SALE) {
    if (isRedesignEnabled && expiresAt) {
      return t(REDESIGNED_PERSONAL_SALE_KEY, {
        date: formatSaleDate(expiresAt)
      });
    }
    return t('sale.footer.personal_sale_offer');
  }
  return null;
};
//# sourceMappingURL=SaleDisclaimer.js.map